import * as Sentry from '@sentry/react'
import { browserTracingIntegration, replayIntegration } from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_WEB_DNS

// Only initialize Sentry if DSN is provided (allows local dev without Sentry)
if (dsn) {
  const isProduction = import.meta.env.MODE === 'production'

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      browserTracingIntegration(),
      // Session replay and full tracing only in production; dev has neither
      ...(isProduction ? [replayIntegration()] : [])
    ],
    tracesSampleRate: isProduction ? 1.0 : 0,
    tracePropagationTargets: [/^\//, /^https:\/\/api\.interax\.com/],
    replaysSessionSampleRate: isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: isProduction ? 1.0 : 0
  })
}
